import { ApplicationConfig, LOCALE_ID, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'; // NOSONAR - required by ngx-spinner's @fadeIn trigger
import { provideRouter } from '@angular/router';
import { provideMarkdown } from 'ngx-markdown';

import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localIt from '@angular/common/locales/it';
import { includeBearerTokenInterceptor } from 'keycloak-angular';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { spinnerInterceptor } from '../utility/spinner/spinner.interceptor';
import { routes } from './app.routes';
import { provideKeycloakAngular } from './configs/keycloak.config';
import { errorInterceptor } from './interceptors/error.interceptor';

registerLocaleData(localIt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideKeycloakAngular(),
    provideHttpClient(withInterceptors([spinnerInterceptor, includeBearerTokenInterceptor, errorInterceptor])),

    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(), // NOSONAR - required by ngx-spinner's @fadeIn trigger
    { provide: LOCALE_ID, useValue: 'it-IT' },
    provideCharts(withDefaultRegisterables()),
    provideMarkdown(),
  ],
};
